var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('RootLayout',[_c('router-view',{key:_vm.$route.fullPath + '&' + _vm.$store.state.time.current})],1),_c('Errors'),_c('ChannelPlugin',{attrs:{"plugin-id":'02e8bc32-c02e-4e6d-a181-057653789c8b'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }